$(function () {
    $(".widget-trend-graph").each(function (idx, element) {
        var dataUrl = $(element).data("url");
        var $canvas = $(element).find("canvas");
        var $content = $(element).find(".trend-graph-content");
        var $countAmt = $(element).find(".count-fig .count-fig-numb");
        var $countUnit = $(element).find(".count-fig .count-fig-unit");
        var $trendContainer = $(element).find(".pc-trend");
        var $trendFig = $(element).find(".fig-trend");
        var $error = $(element).find(".trend-graph-error");
        var canvas = $canvas.get(0);

        if (!canvas) return;

        /**
         * Processes the data retrieved from the server
         */
        var _processData = function (d) {
            if (!d) {
                _showError("Invalid data received");
                return;
            }

            //if (d.length == 0) {
            //    $error.hide();
            //    $spinner.hide();
            //    $canvas.hide();
            //    $empty.show();
            //    return;
            //}

            var chartLabels = d.Labels;

            $countAmt.html(d.Count);
            $countUnit.html(d.CountUnit);

            var up = d.Trend > 0;
            $trendFig.html(Math.abs(Math.round(d.Trend)).toString() + "%");

            if (up) {
                $trendContainer.addClass("trend-up").removeClass("trend-down");
            }
            else {
                $trendContainer.addClass("trend-down").removeClass("trend-up");
            }

            if (d.Trend == 0) {
                $trendContainer.removeClass("trend-down").removeClass("trend-up");
            }

            //$spinner.hide();
            $content.show();

            var context = canvas.getContext('2d');

            var chart = new Chart(context, {
                type: 'line',
                data: {
                    labels: chartLabels,
                    datasets: [{
                        label: "Current Period",
                        data: d.CurrentPeriod.Values,
                        pointRadius: 0,
                        cubicInterpolationMode: 'monotone',
                        fill: false,
                        lineTension: 0.4,
                        backgroundColor: 'rgba(54, 162, 235, .8)',
                        borderColor: 'rgba(54, 162, 235, .8)',
                        borderWidth: 2
                    }, {
                            label: 'Previous Period',
                            data: d.PreviousPeriod.Values,
                            pointRadius: 0,
                            cubicInterpolationMode: 'monotone',
                            fill: false,
                            lineTension: 0.4,
                            backgroundColor: 'rgba(255, 152, 0, .8)',
                            borderColor: 'rgba(255, 152, 0, .8)',
                            borderDash: [2, 4],
                            borderWidth: 2
                        }]
                },
                options: {
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: { display: false },
                            gridLines: { display: false, drawBorder: false }
                        }],
                        xAxes: [{
                            display: true,
                            ticks: { display: true },
                            gridLines: { display: false, drawBorder: true }
                        }]
                    }
                }
            });
        }

        /**
         * Displays an error message
         */
        var _showError = function (err) {
            $content.hide();
            //$spinner.hide();

            if (err) {
                $error.find("p").html(err);
            }

            $error.show();
        };

        /**
         * Fetches the chart data from the data url
         */
        var _fetchData = function () {
            $.ajax({
                url: dataUrl,
                method: 'GET',
                dataType: 'json',
                success: function (d) {
                    _processData(d);
                },
                error: function (x, s, e) {
                    _showError();
                }
            });
        }

        _fetchData();
    });
});